import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { filter } from 'lodash';
import * as moment from 'moment';
import { Moment } from 'moment';
import { Observable } from 'rxjs/Observable';
import { ITimesheetApproval } from '../../../typings/api';
import { ISwipe } from '../../../typings/timetracker/timetracker';
import { WeekSelectorComponent } from '../../components/week-selector/week-selector';
import { Auth0Provider } from '../../providers/auth0.provider';
import { API_ENDPOINT } from '../../providers/generic.service';
import { TimesheetService } from '../timesheets/providers/timesheet.service';
import { WeekStatusService } from './week-status.service';
/**
 * Generated class for the WeekStatusPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-week-status',
  templateUrl: 'week-status.html',
})
export class WeekStatusPage {

  public forgotten$: Observable<ISwipe[]>;
  public approved$: Observable<ITimesheetApproval[]>;
  public open$: Observable<ITimesheetApproval[]>;

  @ViewChild( 'weekSelector' ) weekSelector: WeekSelectorComponent;

  /**
   * The moment to select
   * @param {Moment} selection
   */
  selectWeek( isoWeek: Moment ): void {


    const currentWeekNumber = isoWeek.isoWeek();
    const currentYear = isoWeek.isoWeekYear();
    // const startOfWeek = isoWeek.startOf( 'week' ).toDate();
    // const endOfWeek   = isoWeek.endOf( 'week' ).toDate();

    this.weekSelector.setWeek( currentWeekNumber, currentYear );
    this.$weekStatusAPI.dispatchUserListDailyActivityTotal( currentYear, currentWeekNumber );
    this.$weekStatusAPI.dispatchForgottenSwipeList( currentYear, currentWeekNumber );
  }

  ngOnInit() {

    const localStorageData = this.$timeService.getStoredTimesheetData();
    const now = moment();

    // Determine selected week and year
    //
    if ( localStorageData.isoWeek && localStorageData.year )
    {
      now.set( 'year', localStorageData.year );
      now.set( 'isoWeek', localStorageData.isoWeek );
    }

    this.selectWeek( now );
    this.approved$  = this.$weekStatusAPI.selectUserListDailyActivityTotals().map( ( items ) => filter( items, item => item.approved === true  ) );
    this.open$      = this.$weekStatusAPI.selectUserListDailyActivityTotals().map( ( items ) => filter( items, item => item.approved === false ) );
    this.forgotten$ = this.$weekStatusAPI.selectForgottenSwipes();
  }

  showTimesheet( approval: ITimesheetApproval ) {
    window.localStorage.setItem( this.$timeService.WEEK_STORAGE_LABEL, `${approval.timesheet_iso_week}` );
    window.localStorage.setItem( this.$timeService.YEAR_STORAGE_LABEL, `${approval.timesheet_year}` );
    window.localStorage.setItem( this.$timeService.USER_STORAGE_LABEL, `${approval.user_id}` );
    this.navCtrl.push( 'TimesheetsPage' );
  }

  downloadTimesheetOverview() {
    /** The current JWT token */
    const token = this.$auth0Provider.token('id');

    /** Preferably I would have used URLSearchParams, but for best support I will do it this way */
    const queryParams = `access_token=${token}`;

    console.log( `[EXPORT-TIMESHEET] Downloading timesheet ${API_ENDPOINT} /timesheets/export/overview/${this.weekSelector.currentYear}/${this.weekSelector.currentWeekNumber}` );
    window.open( API_ENDPOINT + `/admin/timesheets/export/overview/${this.weekSelector.currentYear}/${this.weekSelector.currentWeekNumber}?${queryParams}` );
  }

  constructor(
    public navCtrl: NavController,
    public $weekStatusAPI: WeekStatusService,
    public navParams: NavParams,
    private $auth0Provider: Auth0Provider,
    private $timeService: TimesheetService
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/pages/week-status/week-status.ts